document.addEventListener('DOMContentLoaded', () => {
  const cloneInputBlocks = document.querySelectorAll('.clone-input');

  const calcMessageHeight = (parent) => {
    const allErrorMsg = parent.querySelectorAll('.fv-plugins-message-container div');
    if (allErrorMsg.length) {
      let errorHeight;

      if (parent.classList.contains('clone-input__item--multiple') && windowWidth() < breakpointSm) {
        const lastError = allErrorMsg[allErrorMsg.length - 1];
        errorHeight = lastError.offsetHeight;
      } else {
        errorHeight = Math.max(...[...allErrorMsg].map((msg) => msg.offsetHeight));
      }

      parent.style.setProperty('--error-height', `${errorHeight + 8}px`);
    } else {
      parent.style.removeProperty('--error-height');
    }
  };

  const attachObserver = (item) => {
    const observer = new MutationObserver(() => {
      if (item.offsetParent !== null) {
        calcMessageHeight(item);
      }
    });

    observer.observe(item, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  };

  cloneInputBlocks.forEach((block) => {
    const listEle = block.querySelector('.clone-input__inner');
    const cloneElem = block.querySelector('.clone-input__item');
    const initialHTML = cloneElem.outerHTML;

    let suffixCounter = 0;
    const generateUniqueSuffix = () => `_${String(suffixCounter++).padStart(2, '0')}`;

    const addMoreBtn = block.querySelector('.clone-input__add-more .btn');

    addMoreBtn?.addEventListener('click', () => {
      const hiddenInput = block.querySelector('.clone-input__item.hide');
      if (!hiddenInput) {
        const clonedItems = document.createElement('div');
        clonedItems.innerHTML = initialHTML.trim();
        const newBlock = clonedItems.firstChild;

        const uniqueSuffix = generateUniqueSuffix();

        newBlock.querySelectorAll('input, label, select, textarea').forEach((element) => {
          if (element.id) {
            const baseId = element.id.replace(/_\d{2}$/, '');
            element.id = baseId + uniqueSuffix;
          }

          if (element.name) {
            const baseName = element.name.replace(/_\d{2}$/, '');
            element.name = baseName + uniqueSuffix;
            element.setAttribute('data-fv-name', element.name);
          }

          if (element.getAttribute('for')) {
            const baseFor = element.getAttribute('for').replace(/_\d{2}$/, '');
            element.setAttribute('for', baseFor + uniqueSuffix);
          }
        });

        block.querySelectorAll('.clone-input__item').forEach((item) => item.classList.remove('last-added'));

        newBlock.classList.add('last-added');
        listEle.appendChild(newBlock);
        calcMessageHeight(newBlock);
        attachObserver(newBlock);
      }

      listEle.querySelectorAll('.clone-input__item').forEach((item) => {
        item.classList.add('is-show');
        item.classList.remove('hide');
      });
    });

    listEle.addEventListener('click', (ev) => {
      if (!ev.target.closest('.delete-button')) return;
      const item = ev.target.closest('.clone-input__item');
      const parentEle = item.closest('.clone-input.clone-input--with-hidden');

      if (!item) return;
      item.remove();

      if (parentEle) return;
      const items = listEle.querySelectorAll('.clone-input__item');
      items.forEach((el) => el.classList.toggle('is-show', items.length > 1));
    });

    // Calc Error Height
    const allCloneListItem = block.querySelectorAll('.clone-input__item');

    allCloneListItem.forEach((item) => {
      calcMessageHeight(item);
      attachObserver(item);
    });
  });
});
